import axios from 'axios'
import Cookies from 'js-cookie'

// Create an axios instance
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL + '/api/v1', // Use environment variable
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// Add a request interceptor to include the Bearer token
apiClient.interceptors.request.use(
  (config) => {
    // Get the token from cookies
    const token = Cookies.get('authToken')

    // If the token exists, add it to the Authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    // Handle the error
    return Promise.reject(error)
  },
)

export default apiClient
